import React from "react";
import { motion } from "framer-motion";

export default function ErrorState({ message = "We couldn't load this right now.", onRetry }) {
  return (
    <motion.div
      className="pm-error"
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35 }}
    >
      <div className="pm-error__mark">!</div>
      <p>{message}</p>
      {onRetry && (
        <button className="pm-btn pm-btn--ghost" onClick={onRetry}>
          Try again
        </button>
      )}
    </motion.div>
  );
}
